'use client';

import { useEffect, useState } from 'react';

/**
 * Simplified Material Symbols font loader
 * Reduced complexity to improve Script Evaluation performance
 */
export function MaterialSymbolsLoader() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    // Delay load significantly to prioritize critical content
    const timer = setTimeout(() => setShouldLoad(true), 800); // Increased to 2s for better FCP
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!shouldLoad) return;

    // Check if already loaded
    if (document.documentElement.classList.contains('material-symbols-loaded')) return;
    
    const existingLink = document.querySelector('link[href*="Material+Symbols"]');
    if (existingLink) return;

    // Create and append the stylesheet link
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    // link.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=swap';
    link.href = '/fonts/material-symbols.css';
    // Simplified loading detection - just wait for stylesheet load
    link.onload = () => {
      // Use Font Loading API if available, otherwise fallback to timeout
      if ('fonts' in document) {
        document.fonts.load('400 24px "Material Symbols Outlined"').then(() => {
          // Single RAF is sufficient for most cases
          requestAnimationFrame(() => {
            document.documentElement.classList.add('material-symbols-loaded');
          });
        }).catch(() => {
          // Fallback on error
          document.documentElement.classList.add('material-symbols-loaded');
        });
      } else {
        // No Font Loading API - simple timeout fallback
        setTimeout(() => {
          document.documentElement.classList.add('material-symbols-loaded');
        }, 500);
      }
    };
    
    // Failsafe: always mark as loaded after 2 seconds (reduced from 3s)
    setTimeout(() => {
      document.documentElement.classList.add('material-symbols-loaded');
    }, 2000);
    
    document.head.appendChild(link);
  }, [shouldLoad]);

  return null;
}
